import React from 'react';
import Header from './Header';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
}));

export default () => {
  const classes = useStyles();

  //   let history = useHistory();
  //   function handleManageClick() {
  //     history.push('/manage');
  //   }

  //   if (!global.auth.isAuthenticated) {
  //     history.push('/login');
  //   }
  return (
    <>
      <Header />

      <div>Home</div>
    </>
  );
};
